import { render, staticRenderFns } from "./customerServiceManage.vue?vue&type=template&id=64ca41e1&scoped=true&"
import script from "./customerServiceManage.vue?vue&type=script&lang=js&"
export * from "./customerServiceManage.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceManage.vue?vue&type=style&index=0&id=64ca41e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca41e1",
  null
  
)

component.options.__file = "customerServiceManage.vue"
export default component.exports